<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <i class="iconfont icon-gerenxinxi" />
              基础信息
            </template>
            <el-row>
              <el-col :span="24">
                <span
                  >照片：
                  <el-image
                    fit="contain"
                    style="width: 150px"
                    :src="detailInfo.collectionPhotos"
                    :preview-src-list="[detailInfo.collectionPhotos]"
                  >
                  </el-image>
                </span>
              </el-col>
              <el-col :span="24">
                <span>姓名：{{ detailInfo.name }}</span>
              </el-col>
              <el-col :span="24">
                <span>性别：{{ detailInfo.sex }}</span>
              </el-col>
              <el-col :span="24">
                <span>民族：{{ detailInfo.nation }}</span>
              </el-col>
              <el-col :span="24">
                <span>文化程度：{{ detailInfo.cultureLevelType }}</span>
              </el-col>
              <el-col :span="24">
                <span>政治面貌：{{ detailInfo.politicCountenance }}</span>
              </el-col>
              <el-col :span="24">
                <span>出生日期：{{ detailInfo.birthday }}</span>
              </el-col>
              <el-col :span="24">
                <span>手机号码：{{ detailInfo.phone }}</span>
              </el-col>
              <el-col :span="24">
                <span>家庭住址：{{ detailInfo.address }}</span>
              </el-col>
              <el-col :span="24">
                <span>证件类型：{{ detailInfo.idCardType }}</span>
              </el-col>
              <el-col :span="24">
                <span>证件号码：{{ detailInfo.idCardNumber }}</span>
              </el-col>
              <el-col :span="24">
                <span>签发机关：{{ detailInfo.iddepart }}</span>
              </el-col>
              <el-col :span="24">
                <span>有效期限：{{ detailInfo.effectiveDate }}</span>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <i class="iconfont icon-jichuxinxi" />
              进场信息
            </template>
            <el-row>
              <el-col :span="24">
                <span>工号：{{ detailInfo.jobNo }}</span>
              </el-col>
              <el-col :span="24">
                <span>所属项目：{{ detailInfo.projectId }}</span>
              </el-col>
              <el-col :span="24">
                <span>所属企业：{{ detailInfo.unitId }}</span>
              </el-col>
              <el-col :span="24">
                <span>所属班组：{{ detailInfo.teamId }}</span>
              </el-col>
              <el-col :span="24">
                <span>人员类型：{{ detailInfo.personnelType }}</span>
              </el-col>
              <el-col v-if="detailInfo.personnelType !== '建筑工人'" :span="24">
                <span>管理岗位：{{ detailInfo.post }}</span>
              </el-col>
              <el-col :span="24">
                <span>所属工种：{{ detailInfo.workType }}</span>
              </el-col>
              <el-col :span="24">
                <span>当前状态：{{ detailInfo.status }}</span>
              </el-col>
              <el-col :span="24">
                <span>工作性质：{{ detailInfo.category }}</span>
              </el-col>
              <el-col :span="24">
                <span>签订合同：{{ detailInfo.hasContract }}</span>
              </el-col>
              <el-col :span="24">
                <span>购买保险：{{ detailInfo.hasBuyInsurance }}</span>
              </el-col>
              <el-col :span="24">
                <span>进场时间：{{ detailInfo.entryTime }}</span>
              </el-col>
              <el-col :span="24">
                <span>退场时间：{{ detailInfo.exitTime }}</span>
              </el-col>
              <el-col :span="24">
                <span></span>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <i class="iconfont icon-jichuxinxi" />
              银行卡号
            </template>
            <el-row>
              <el-col :span="24">
                <span>银行卡号：{{ detailInfo.payRollBankCardNumber }}</span>
              </el-col>
              <el-col :span="24">
                <span>银行名称：{{ detailInfo.payRollBankName }}</span>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <i class="iconfont icon-jichuxinxi" />
              其他
            </template>
            <el-row>
              <el-col :span="24">
                <span>备注信息：{{ detailInfo.remark }}</span>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postDetail } from "@/api/app/roster";
import { postListUnit } from "@/api/app/unit";
import { postTeamDetail } from "@/api/app/team";
import { postProjectId } from "@/api/app/project";
export default {
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      detailInfo: {},
    };
  },
  created() {
    this.detail();
  },
  methods: {
    // 获取详情
    detail() {
      postDetail(JSON.stringify(this.$store.state.app.itemId)).then((a) => {
        this.detailInfo = a.data;
        // 人员类型
        if (a.data.personnelType == 10) {
          this.detailInfo.personnelType = "管理人员";
        } else if (a.data.personnelType == 20) {
          this.detailInfo.personnelType = "建筑工人";
        }
        // 工作性质
        if (a.data.category == 1) {
          this.detailInfo.category = "合同工";
        } else if (a.data.category == 2) {
          this.detailInfo.category = "临时工";
        }
        // 签订合同
        if (a.data.hasContract == 1) {
          this.detailInfo.hasContract = "已签订";
        } else if (a.data.hasContract == 2) {
          this.detailInfo.hasContract = "未签订";
        }
        // 购买保险
        if (a.data.hasBuyInsurance == 1) {
          this.detailInfo.hasBuyInsurance = "已购买";
        } else if (a.data.hasBuyInsurance == 2) {
          this.detailInfo.hasBuyInsurance = "未购买";
        }
        // 文化程度
        postDictCode("education_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.cultureLevelType) {
              this.detailInfo.cultureLevelType = item.label;
            }
          });
        });
        // 政治面貌
        postDictCode("outlook_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.politicCountenance) {
              this.detailInfo.politicCountenance = item.label;
            }
          });
        });
        // 证件类型
        postDictCode("certificate_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.idCardType) {
              this.detailInfo.idCardType = item.label;
            }
          });
        });
        // 管理岗位
        postDictCode("management_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.post) {
              this.detailInfo.post = item.label;
            }
          });
        });
        // 所属工种
        postDictCode("work_type").then((b) => {
          b.data.find((item) => {
            if (item.value == a.data.workType) {
              this.detailInfo.workType = item.label;
            }
          });
        });
        // 所属项目
        postProjectId(a.data.projectId).then((b) => {
          this.detailInfo.projectId = b.data.name;
        });
        // 所属企业
        postListUnit(a.data.projectId).then((b) => {
          b.data.find((item) => {
            if (a.data.unitId == item.id) {
              this.detailInfo.unitId = item.title;
            }
          });
        });
        // 所属班组
        postTeamDetail(a.data.teamId).then((b) => {
          this.detailInfo.teamId = b.data.name;
        });

        // 当前状态
        this.$store.state.app.dict.find((item) => {
          if (item.value == a.data.status) {
            this.detailInfo.status = item.label;
          }
        });
      });
    },
    showImage(index) {
      ImagePreview({
        images: [index],
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 40px;
  padding: 10px;
  min-height: 100vh;

  background-color: #f0f0f0;
}
.content {
  .el-card {
    margin-bottom: 10px;
    .el-tag {
      margin-bottom: 5px;
    }
    p,
    .el-col {
      font-size: 14px;
      margin-bottom: 5px;
    }
    span {
      font-size: 14px;
    }
    .img {
      img {
        width: 130px;
        height: 130px;
        border-radius: 4px;
      }
    }
  }
}
</style>
